import React, { useRef, memo, useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './ReviewEditor.css';

import RichTextEditor from 'quill-react-commercial';
import 'quill-react-commercial/lib/index.css';

// Ensure proper list format registration
//const List = Quill.import('formats/list');
//const ListItem = Quill.import('formats/list/item');
//Quill.register(List, true);
//Quill.register(ListItem, true);

const ReviewEditor = memo(({ value, readOnly, onChange, placeholder = "Enter your comments..." }) => {
  //const [internalValue, setInternalValue] = useState(value || '');

  const [initialValue, setInitialValue] = useState(value || '');
  const isInternalChange = useRef(false);

  // Simple modules configuration with only basic formatting
  const modules = React.useMemo(() => ({
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['clean']
    ],
    clipboard: {
      matchVisual: false,
    }
  }), []);
  
  const formats = React.useMemo(() => [
    'bold', 'italic', 'underline',
    'list', 'bullet'
  ], []);

  // Update internal value when prop changes (only when different)
  useEffect(() => {
    if (isInternalChange.current) {
      isInternalChange.current = false;
    } else {
      setInitialValue(value);
    }
  }, [value]);

  const quillRef = useRef({});
  const getQuill = (quillIns) => {
    quillRef.current = quillIns;
  };

  const handleChange = React.useCallback(() => {
    const content = quillRef.current.getSemanticHTML();
    isInternalChange.current=true;
    onChange(content);
  }, [onChange]);
  
  return (
    <div className="review-editor">
      {false &&
      <ReactQuill
        theme="snow"
        ref={quillRef}
        value={initialValue}
        readOnly={readOnly}
        onChange={handleChange}
        placeholder={placeholder}
        bounds=".review-editor"
        modules={modules}
        formats={formats}
      />}
      <RichTextEditor 
        modules={{
          table: {},
          codeHighlight: false,
          toolbarOptions:[
            ['bold', 'italic', 'underline'],
            [{list:'ordered'},{list:'bullet'}],['clean']
          ]
        }}
        getQuill={getQuill}
        content={initialValue}
        readOnly={readOnly}
        onChange={handleChange}
        placeholder={placeholder}
        bounds=".review-editor"
      />
    </div>

  );
});

ReviewEditor.displayName = 'ReviewEditor';

export default ReviewEditor;
